module.exports = __webpack_public_path__ + "static/media/azapfy-icone.425b54a7.png";